    document.addEventListener('DOMContentLoaded', function() {
    // Get all elements needed for navigation only
    const tabs = document.querySelectorAll('.section-quiz-tab');
    const progressBar = document.getElementById('progress');
    const previousButton = document.getElementById('previous-tab');
    let currentTab = 0;

    // IMPORTANT: JavaScript only handles navigation and UI validation
    // Form submission is handled by the browser normally

    // Update progress bar
    function updateProgress() {
        const progress = ((currentTab + 1) / tabs.length) * 100;
        progressBar.style.width = progress + '%';
        
        // Update step indicator for each tab
        const stepIndicators = document.querySelectorAll('.step-indicator');
        stepIndicators.forEach(indicator => {
            indicator.textContent = `Step ${currentTab + 1} of ${tabs.length}`;
        });
    }

    // Show the current tab
    function showTab(index) {
        // Hide all tabs
        tabs.forEach(tab => {
            tab.classList.remove('quiz-tab-active');
        });
        
        // Show the specified tab
        tabs[index].classList.add('quiz-tab-active');
        
        // Update current tab index
        currentTab = index;
        
        // Update progress bar
        updateProgress();
        
        // Show or hide previous button
        if (currentTab === 0) {
            previousButton.style.display = 'none';
        } else {
            previousButton.style.display = 'block';
        }
    }

    // Check if at least one checkbox is checked in a tab (for UI validation only)
    function checkCheckboxesInTab(tab) {
        const checkboxes = tab.querySelectorAll('input[type="checkbox"]');
        if (checkboxes.length === 0) return true;
        
        let atLeastOneChecked = false;
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                atLeastOneChecked = true;
            }
        });
        
        return atLeastOneChecked;
    }

    // Validate tab UI before proceeding to next tab
    function validateTabUI(tabIndex) {
        const tab = tabs[tabIndex];
        const radioButtons = tab.querySelectorAll('input[type="radio"]');
        const checkboxes = tab.querySelectorAll('input[type="checkbox"]');
        const selects = tab.querySelectorAll('select');
        const textInputs = tab.querySelectorAll('input[type="text"], input[type="number"], input[type="email"]');
        let isValid = true;
        
        // Hide all error messages first
        const errorElement = document.getElementById(`error-tab${tabIndex + 1}`);
        if (errorElement) {
            errorElement.style.display = 'none';
        }
        
        // Check select fields (if any) - UI validation only
        selects.forEach(select => {
            if (!select.value) {
                isValid = false;
                if (errorElement) {
                    errorElement.style.display = 'block';
                }
            }
        });
        
        // Check radio buttons (if any) - UI validation only
        if (radioButtons.length > 0) {
            let checked = false;
            radioButtons.forEach(radio => {
                if (radio.checked) {
                    checked = true;
                }
            });
            
            if (!checked) {
                isValid = false;
                if (errorElement) {
                    errorElement.style.display = 'block';
                }
            }
        }
        
        // Check checkboxes (if any and required for UI) - only for tabs 4 and 7
        if (checkboxes.length > 0 && (tabIndex === 3 || tabIndex === 6)) {
            if (!checkCheckboxesInTab(tab)) {
                isValid = false;
                if (errorElement) {
                    errorElement.style.display = 'block';
                }
            }
        }
        
        // Check text inputs (if any) - UI validation only
        if (textInputs.length > 0 && tabIndex === 4) {
            let allFilled = true;
            textInputs.forEach(input => {
                if (!input.value.trim()) {
                    allFilled = false;
                }
            });
            
            if (!allFilled) {
                isValid = false;
                if (errorElement) {
                    errorElement.style.display = 'block';
                }
            }
        }
        
        return isValid;
    }

    // Setup event listeners for form inputs - for navigation only
    function setupNavigationListeners() {
        tabs.forEach((tab, tabIndex) => {
            // Radio buttons - enable next button when selected
            const radioButtons = tab.querySelectorAll('input[type="radio"]');
            radioButtons.forEach(radio => {
                radio.addEventListener('change', function() {
                    const nextButton = tab.querySelector('.button-next');
                    
                    if (nextButton) {
                        nextButton.disabled = false;
                    }
                    
                    // Hide error message if shown
                    const errorElement = document.getElementById(`error-tab${tabIndex + 1}`);
                    if (errorElement) {
                        errorElement.style.display = 'none';
                    }
                });
            });
            
            // Checkboxes - enable next button when at least one is checked
            const checkboxes = tab.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', function() {
                    const nextButton = tab.querySelector('.button-next');
                    
                    if (nextButton && checkCheckboxesInTab(tab)) {
                        nextButton.disabled = false;
                    } else if (nextButton) {
                        nextButton.disabled = true;
                    }
                    
                    // Hide error message if shown
                    const errorElement = document.getElementById(`error-tab${tabIndex + 1}`);
                    if (errorElement) {
                        errorElement.style.display = 'none';
                    }
                });
            });
            
            // Select fields - hide errors on change
            const selects = tab.querySelectorAll('select');
            selects.forEach(select => {
                select.addEventListener('change', function() {
                    const errorElement = document.getElementById(`error-tab${tabIndex + 1}`);
                    if (errorElement) {
                        errorElement.style.display = 'none';
                    }
                });
            });
            
            // Text inputs - hide errors on input
            const textInputs = tab.querySelectorAll('input[type="text"], input[type="number"], input[type="email"]');
            textInputs.forEach(input => {
                input.addEventListener('input', function() {
                    const errorElement = document.getElementById(`error-tab${tabIndex + 1}`);
                    if (errorElement) {
                        errorElement.style.display = 'none';
                    }
                });
            });
        });
    }

    // Navigate to next tab
    function navigateToNextTab() {
        if (currentTab < tabs.length - 1) {
            showTab(currentTab + 1);
        }
    }

    // Setup next button functionality - for navigation only
    function setupNextButtons() {
        const nextButtons = document.querySelectorAll('.button-next');
        
        nextButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Validate current tab UI before proceeding
                if (validateTabUI(currentTab)) {
                    navigateToNextTab();
                }
            });
        });
    }

    // Previous button functionality - for navigation only
    previousButton.addEventListener('click', function() {
        if (currentTab > 0) {
            showTab(currentTab - 1);
        }
    });

    // IMPORTANT: NO form submission interference
    // The form will submit normally through the browser
    // JavaScript only handles the tab navigation

    // Initialize the form navigation
    showTab(0);
    setupNextButtons();
    setupNavigationListeners();

    // Optional: Auto-enable next buttons for tabs with selects
    // This makes the user experience smoother
    tabs.forEach((tab, index) => {
        const selects = tab.querySelectorAll('select');
        const textInputs = tab.querySelectorAll('input[type="text"], input[type="number"]');
        const nextButton = tab.querySelector('.button-next');
        
        // For tabs with selects, enable next button by default
        if (selects.length > 0 && index !== 7) { // Not the last tab
            if (nextButton && !nextButton.classList.contains('button-submit')) {
                nextButton.disabled = false;
            }
        }
        
        // For tabs with text inputs, enable next button by default
        if (textInputs.length > 0 && index === 4) {
            if (nextButton) {
                nextButton.disabled = false;
            }
        }
    });
    });